// extracted by mini-css-extract-plugin
export default {"user":"AvatarItem_user__Opu5M","user__avatar":"AvatarItem_user__avatar__31huY"};